var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-tab-container"},[_c('ProductsTable',{attrs:{"categories":_vm.categories,"products":_vm.products}}),_c('Pagination',{attrs:{"classes":"orange","items_by_page_value":20,"total":_vm.total_items,"page":_vm.page,"page_limit":5,"skipScroll":true},on:{"change":function($event){return _vm.updatePage($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }